import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api' });

API.interceptors.request.use(cfg => {
  const tok = localStorage.getItem('q_token');
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

API.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('q_token'); localStorage.removeItem('q_user');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

export const login          = d  => API.post('/auth/login', d);
export const getProfile     = () => API.get('/auth/profile');
export const getUsers       = () => API.get('/users');
export const createUser     = d  => API.post('/users', d);
export const updateUser     = (id,d) => API.put(`/users/${id}`, d);
export const deleteUser     = id => API.delete(`/users/${id}`);
export const getCurrencies  = () => API.get('/currencies');
export const updateCurrency = (id,d) => API.put(`/currencies/${id}`, d);
export const getCurrencyLogs= () => API.get('/currencies/logs');
export const getInsurance   = () => API.get('/insurance');
export const createInsurance= d  => API.post('/insurance', d);
export const updateInsurance= (id,d) => API.put(`/insurance/${id}`, d);
export const deleteInsurance= id => API.delete(`/insurance/${id}`);
export const getCountryConfig = country => API.get(`/config/${encodeURIComponent(country)}`);
export const getAllConfigs   = () => API.get('/config');
export const updateConfig   = (id,d) => API.put(`/config/${id}`, d);
export const calculate          = d  => API.post('/calculate', d);
export const calculateComparison = d  => API.post('/calculate/comparison', d);

export const getAllCustomBurdens   = () => API.get('/custom-burdens');
export const getCustomBurdensByCountry = country => API.get(`/custom-burdens/${encodeURIComponent(country)}`);
export const createCustomBurden    = d  => API.post('/custom-burdens', d);
export const updateCustomBurden    = (id,d) => API.put(`/custom-burdens/${id}`, d);
export const deleteCustomBurden    = id => API.delete(`/custom-burdens/${id}`);

const download = async (url, body, filename) => {
  const res = await API.post(url, body, { responseType: 'blob' });
  const href = window.URL.createObjectURL(new Blob([res.data]));
  const a = Object.assign(document.createElement('a'), { href, download: filename });
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); window.URL.revokeObjectURL(href);
};

export const exportPDF   = body => download('/calculate/export/pdf',   body, `Quoteology_${body.country.replace(/ /g,'_')}.pdf`);
export const exportExcel = body => download('/calculate/export/excel', body, `Quoteology_${body.country.replace(/ /g,'_')}.xlsx`);
export const exportComparisonPDF   = body => download('/calculate/comparison/export/pdf',   body, 'Quoteology_Comparison.pdf');
export const exportComparisonExcel = body => download('/calculate/comparison/export/excel', body, 'Quoteology_Comparison.xlsx');

export const getCalculations      = () => API.get('/calculations');
export const getClientSuggestions = q  => API.get(`/calculations/clients?q=${encodeURIComponent(q)}`);
export const deleteCalculation    = id => API.delete(`/calculations/${id}`);

export default API;

// ── Organisation & Subscription ──────────────────────────────────────────────
export const signup            = (data)  => API.post('/signup', data);
export const getMyOrg          = ()      => API.get('/my-org');
export const createOrgUser     = (data)  => API.post('/my-org/users', data);
export const getTopUpHistory   = ()      => API.get('/subscription/topups');
export const purchaseTopUp     = (data)  => API.post('/subscription/topup', data);
export const createCheckout    = (data)  => API.post('/subscription/checkout', data);
// Quoteology internal admin — org management
export const listOrgs          = ()      => API.get('/admin/orgs');
export const createOrg         = (data)  => API.post('/admin/orgs', data);
export const updateOrg         = (id, d) => API.put(`/admin/orgs/${id}`, d);